<script lang="ts" setup>
import DefinitionListSection from '../../DefinitionListSection.vue';
import WhereToConsultCard from '../../WhereToConsult/WhereToConsultCard.vue';
import ExaminationItemsImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/WhereToConsultCard/10_examination_items.png/10_examination_items.webp';
import MortgageFlowImg from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/templates/ProductLpTemplate/mortgage/WhereToConsultCard/11_mortgage_flow.jpg/11_mortgage_flow.webp';
import PinchImageModal from '~theme/components/organisms/PinchImageModal.vue';

defineProps<{
  imageNumber: number;
}>();
</script>

<template>
  <WhereToConsultCard
    title="住宅ローンの負担を軽減するためのポイント"
    :image-number="imageNumber"
  >
    <p>
      住宅金融支援機構の「<NuxtLink
        href="https://www.jhf.go.jp/files/400364610.pdf#page=27"
        external
        target="_blank"
        >2022年度住宅ローン貸出動向調査</NuxtLink
      >」によると、住宅ローン本審査で重視度が増していると考えられている審査項目は以下の通りです。
    </p>
    <PinchImageModal :src="ExaminationItemsImg" />
    <p>
      「<strong>返済負担率（毎月返済額/月収）</strong>
      」が最も多く、次いで、「職種・勤務先・雇用形態」、「借入比率（借入額/担保評価）」という結果でした。
    </p>
    <p>
      金融機関が定めている返済負担率の審査基準は、おおむね30～40％程度です。返済負担率は、「年間返済額÷年収×100」で計算できます。
    </p>
    <p>住宅ローンの審査の流れは以下の通りです。</p>
    <PinchImageModal :src="MortgageFlowImg" />
    <DefinitionListSection>
      <dt>住宅ローンの流れ</dt>
      <dd>
        <ol>
          <li>
            住宅ローン情報収集・相談<br />まずは情報収集を行い、希望の条件の住宅ローンを探しましょう。モゲチェックを使えば、ランキング形式で住宅ローンを比較でき、必要に応じて専門家への相談も無料でできるので効率的です。
          </li>
          <li>
            事前審査（仮審査）の申し込み<br />気になる住宅ローンが見つかったら、事前審査の申込を行います。
            <br />
            事前審査では申込者の本人確認書類などの準備が必要ですが、これもモゲチェックを使えば追加情報を入力するだけで事前審査を代行してもらえるので手間を最小限にできます。
          </li>
          <li>
            本審査（正式審査）の申し込み<br />事前審査の通過後は本審査に申し込みます。本審査では事前審査よりも必要書類が増え、さらに細かい審査が行われます。
          </li>
          <li>
            住宅ローン契約の手続き<br />本審査の承認が無事おりれば、不動産売買契約の締結と住宅ローンの契約手続きを行います。
          </li>
          <li>
            融資実行<br />物件の引き渡しと同時に、住宅ローンの融資が始まります。事前審査の申し込みから融資実行まで、1ヶ月程度時間がかかることが想定されます。
          </li>
        </ol>
      </dd>
    </DefinitionListSection>
  </WhereToConsultCard>
</template>

<style module lang="scss"></style>
